export default __webpack_public_path__ + "static/media/company-customers.91d7effd.svg";